export type PageState = {
  ordersDay: string | null
  foodSearch: string
  foodCategory: 'all' | 'Entree' | 'Side' | 'other'
  commentsFilter: 'ALL' | 'NOT_REPLIED' | 'REPLIED'
}

// Session UI only: fixed filter slots and a bounded set of scroll positions.
export function createPageNavigationState() {
  const values: PageState = { ordersDay: null, foodSearch: '', foodCategory: 'all', commentsFilter: 'ALL' }
  const scroll = new Map<string, number>()
  return {
    get<K extends keyof PageState>(key: K): PageState[K] { return values[key] },
    set<K extends keyof PageState>(key: K, value: PageState[K]) { values[key] = value },
    getScroll(key: string) { return scroll.get(key) ?? 0 },
    setScroll(key: string, value: number) {
      scroll.delete(key)
      scroll.set(key, value)
      if (scroll.size > 24) scroll.delete(scroll.keys().next().value!)
    },
  }
}
